import { qsa } from '@fluorescent/dom';

import { section } from '@/glow';
import Accordions from '@/lib/accordion';
import { wrapIframes, wrapTables } from '@/lib/rte';

section('page', {
  onLoad() {
    this.accordions = Accordions(qsa('.accordion', this.container));
    wrapIframes(qsa('iframe', this.container));
    wrapTables(qsa('table', this.container));
  },

  onUnload() {
    this.accordions.destroy();
  },
});
